module.exports = __webpack_public_path__ + "img/ranchcap.0e6cffd3.png";